import Container from '~/components/common/container';
import { useTranslate } from '~/i18n';

import {
   EventsAndCon,
   Experiences,
   Game,
   Theater,
   Treasure,
   Diving,
   Camp,
   Space,
   Tourism,
   Museum,
   VR,
   Art,
   Restuarant,
   Golf,
   Saloon,
   Classes,
   Packages,
} from '~/svgs/business/booking-categories';
/**
 * this component has a list of Business Values and a list of Advantage Section
 */

const BusinessValues = ({ content }: any) => {
   const { translate } = useTranslate();
   const { title, description } = content;
   const businessCategories = [
      {
         category: translate({ id: 'business:tickets' }),
         list: [
            {
               svg: <EventsAndCon />,
               name: translate({ id: 'business:events and con' }),
            },
            {
               svg: <Experiences />,
               name: translate({ id: 'business:experiences' }),
            },
            {
               svg: <Game />,
               name: translate({ id: 'business:esports' }),
            },
            {
               svg: <Theater />,
               name: translate({ id: 'business:cinema' }),
            },
         ],
      },
      {
         category: translate({ id: 'business:adventures' }),
         list: [
            {
               svg: <Treasure />,
               name: translate({ id: 'business:treasure' }),
            },
            {
               svg: <Diving />,
               name: translate({ id: 'business:diving' }),
            },
            {
               svg: <Camp />,
               name: translate({ id: 'business:summer camps' }),
            },
            {
               svg: <Space />,
               name: translate({ id: 'business:space' }),
            },
         ],
      },
      {
         category: translate({ id: 'business:tour' }),
         list: [
            {
               svg: <Tourism />,
               name: translate({ id: 'business:tourism' }),
            },
            {
               svg: <Museum />,
               name: translate({ id: 'business:museums' }),
            },
            {
               svg: <VR />,
               name: translate({ id: 'business:vr' }),
            },
            {
               svg: <Art />,
               name: translate({ id: 'business:art' }),
            },
         ],
      },
      {
         category: translate({ id: 'business:food' }),
         list: [
            {
               svg: <Restuarant />,
               name: translate({ id: 'business:resturant' }),
            },
         ],
      },
      {
         category: translate({ id: 'business:sports' }),
         list: [
            {
               svg: <Golf />,
               name: translate({ id: 'business:golf' }),
            },
            {
               svg: <Saloon />,
               name: translate({ id: 'business:home salom' }),
            },
         ],
      },
      {
         category: translate({ id: 'business:classes and training' }),
         list: [
            {
               svg: <Classes />,
               name: translate({ id: 'business:online' }),
            },
            {
               svg: <Packages />,
               name: translate({ id: 'business:packages' }),
            },
         ],
      },
   ];
   return (
      <Container>
         <div id="business-value" className="py-[53px] lg:py-[108px]">
            <div className="font-semibold text-[30px] lg:text-[60px] pt-12 lg:pt-[76px] pb-[12px] lg:pb-[18px] lg:px-32 text-center">
               {title}
            </div>
            <div className="text-[17px] lg:text-[26px] text-[#0552BC] lg:pb-[44px] pb-[18px] text-center">
               {description}
            </div>
            <div className="grid px-8 gap-x-48 gap-y-16 lg:grid-cols-3 ">
               {businessCategories.map((value, key) => (
                  <div key={key}>
                     <div className="text-[26px] font-bold pb-[21px]">{value.category}</div>
                     <div>
                        {value.list.map((value, key) => (
                           <div key={key} className="flex py-2">
                              <div>
                                 <div className="w-[24px] h-[24px] ltr:mr-2 rtl:ml-2">
                                    {value.svg}
                                 </div>
                              </div>
                              <div>{value.name}</div>
                           </div>
                        ))}
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </Container>
   );
};
export default BusinessValues;
